(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
/* Progressive enhancement: smooth animation + optional single-open behaviour.
   Works fine without JS — <details> stays fully functional and crawlable. */
(function () {
  document.querySelectorAll('.faqx').forEach(function (root) {
    var singleOpen = root.getAttribute('data-single-open') === 'true';
    var items = root.querySelectorAll('.faqx__item');

    items.forEach(function (item) {
      var summary = item.querySelector('.faqx__q');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        // Animate close so the grid-rows transition can run before [open] flips off
        if (item.hasAttribute('open')) {
          e.preventDefault();
          var wrap = item.querySelector('.faqx__a-wrap');
          if (wrap) {
            wrap.style.gridTemplateRows = '0fr';
            wrap.addEventListener('transitionend', function handler() {
              item.removeAttribute('open');
              wrap.style.gridTemplateRows = '';
              wrap.removeEventListener('transitionend', handler);
            }, { once: true });
          } else {
            item.removeAttribute('open');
          }
        } else if (singleOpen) {
          items.forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
